export default {
  dosingRecommendations: [],
  symptomDetails: {},
  feverRecommendationNavigationIndex: 1,
  feverRecommendations: [],
  temperatureRequiredError: false,
  patientAgeRequiredError: false,
  referral: ''
}
